
import React from 'react';
//import { useGetList } from 'react-admin';
import Welcome from './Welcome';


const Dashboard = () => {
    
    return (
        <>
            <Welcome />            
        </>
    );
};

export default Dashboard;